import inView from './includes/inview'
import 'fullpage.js/vendors/scrolloverflow'
import fullpage from 'fullpage.js'

export default {
    init() {

        // Enable fullpage.js
        this.isDesktop = false
        this.isMobile = false

        // Fulpage variables
        this.fullPageCreated = false
        this.fullPageDestroyed = false

        // Determine screen size
        this.windowSize()

        // Init or destroy fullpage on resize
        $(window).resize( () => {
            // Determine screen size
            this.windowSize()

            // Desktop
            if (this.isDesktop) {

                // Has fullpage already been initiated
                if (!this.fullPageCreated) {
                    this.fullpageInit()
                }
            // Mobile
            } else {

                // Has fullpage already been destroyed
                if (!this.fullPageDestroyed) {
                    this.fullpageDestroy()
                }
            }
        })

        // Initiate fullpage slides if desktop
        if (this.isDesktop) {
            this.fullpageInit()
        }

    },
    windowSize() {

        const windowWidth = $(window).width()

        if (windowWidth > 991) {
            this.isDesktop = true
            this.isMobile = false
        } else {
            this.isMobile = true
            this.isDesktop = false
        }

    },
    fullpageInit() {

        new fullpage('#fullpage', {
            verticalCentered: false,
            autoScrolling: true,
            scrollOverflow: true,
            licenseKey: '85463E12-1487441A-8D959CFF-8D76E291',
            onLeave: function(origin, destination, direction){
                setTimeout( () => {
                    $(destination.item).find('.iv-wp').addClass('el-iv')
                }, 500)
            }
        })

        this.fullPageCreated = true
        this.fullPageDestroyed = false

    },
    fullpageDestroy() {

        const fullpage_api = window.fullpage_api

        fullpage_api.destroy('all')

        this.fullPageDestroyed = true
        this.fullPageCreated = false

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js